import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { Typography } from '@web-chat-core/ui-kit';
import { Modal } from 'features/Modals';
import { selectRoom } from 'state/selectors';
import { useChat } from 'useCase/chat/useChat';
import { MessageField } from './components/MessageField';
import { MessagesList } from './components/MessagesList';

export const ChatModal = observer(() => {
    const { t } = useTranslation();
    const { prepareAndAddMessage } = useChat();
    const room = selectRoom();

    // флаг о том, что есть новое сообщение, отправленное текущим пользователем
    const [hasNewSentMessage, setHasNewSentMessage] = useState(false);

    const handleMessageSend = useCallback(
        (payload: string) => {
            if (!room) return;

            const participant = room.localParticipant;

            participant
                .publishData(new TextEncoder().encode(payload), {
                    topic: 'message',
                    reliable: true,
                })
                .then(() => {
                    // В собственном сообщении отображается 'Вы' вместо имени, при необходимости имя можно взять из room.localParticipant.metadata
                    prepareAndAddMessage({
                        text: payload,
                        own: true,
                        name: t('web_call_you_started'),
                        senderId: participant.identity,
                        sid: participant.sid,
                    });
                    setHasNewSentMessage(true);
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        [room, t],
    );

    const handleScrollAcknowledged = useCallback(() => {
        setHasNewSentMessage(false);
    }, []);

    return (
        <Modal
            header={<Typography variant="body1">{t('web_call_chat')}</Typography>}
            footer={<MessageField onMessageSend={handleMessageSend} />}
        >
            <MessagesList hasNewSentMessage={hasNewSentMessage} onScrollAcknowledged={handleScrollAcknowledged} />
        </Modal>
    );
});

ChatModal.displayName = 'ChatModal';
